import { Analytics } from './analytics'

export enum VgcAnalyticsEvent {
   vgcLoadSampleData = 'Load VGC dummy data',
   vgcCreateNewCalculation = 'New VGC scenario created',
   vgcGenerateReport = 'Generate VGC report',
   vgcDownloadPdf = 'VGC report downloaded',
   vgcTacticSwitch = 'Tactics enabled',
   vgcOpened = 'VGC opened'
}

export default class VgcAnalytics implements Analytics {
   static createNewCalculation = () => {
      return Analytics.emitEvent(VgcAnalyticsEvent.vgcCreateNewCalculation, undefined)
   }

   static generateReport = () => {
      return Analytics.emitEvent(VgcAnalyticsEvent.vgcGenerateReport, undefined)
   }

   static downloadPdf = () => {
      return Analytics.emitEvent(VgcAnalyticsEvent.vgcDownloadPdf, undefined)
   }

   static loadDummyData = () => {
      return Analytics.emitEvent(VgcAnalyticsEvent.vgcLoadSampleData, undefined)
   }

   static enableTactics = (enabled: boolean) => {
      return Analytics.emitEvent(VgcAnalyticsEvent.vgcTacticSwitch, { "Enabled": enabled })
   }

   static openVgcFromMainMenu = () => {
      return Analytics.emitEvent(VgcAnalyticsEvent.vgcOpened, {
         "Initiated from": 'Main menu'
      })
   }

   static openVgcFromGettingStartedChecklist = () => {
      return Analytics.emitEvent(VgcAnalyticsEvent.vgcOpened, {
         "Initiated from": 'Getting started checklist'
      })
   }

   static openVgcFromWorkSpace = (processName: string) => {
      return Analytics.emitEvent(VgcAnalyticsEvent.vgcOpened, {
         "Process name": processName,
         "Initiated from": 'Workspace'
      })
   }

   static openVgcFromMeeting = () => {
      return Analytics.emitEvent(VgcAnalyticsEvent.vgcOpened, {
         "Initiated from": 'Meeting'
      })
   }
}
